export enum PluginEnum {
  MULTIPRESS ='multipress',
  PRINTOCLOCK ='printoclock',
  SYNC_DATABASE = 'sync-database',
  GIM = 'gim'
}
